import gql from "graphql-tag";

export const GET_TYPE_OF_ATTRACTIONS = gql`
query type_of_attractions {
    type_of_attractions {
      id
      name
      image_url
      image_path
    }
  }
  
`;